import React from 'react';
import { Users, MessageSquare, Send, Award, Settings, Calendar, Sparkles } from 'lucide-react';

const TABS = [
  { id: 'signups', label: 'OTA Signups', icon: Users, testId: 'tab-signups', countKey: 'signups' },
  { id: 'contacts', label: 'Contact Messages', icon: MessageSquare, testId: 'tab-contacts', countKey: 'unread' },
  { id: 'email', label: 'Email Center', icon: Send, testId: 'tab-email' },
  { id: 'sponsors', label: 'Sponsors', icon: Award, testId: 'tab-sponsors' },
  { id: 'event', label: 'Event Editor', icon: Calendar, testId: 'tab-event' },
  { id: 'cheer', label: 'Cheer Editor', icon: Sparkles, testId: 'tab-cheer' },
  { id: 'settings', label: 'Settings', icon: Settings, testId: 'tab-settings' },
];

const AdminTabs = ({ activeTab, onTabChange, signupsCount, unreadCount }) => (
  <div className="admin-tabs">
    {TABS.map((tab) => {
      const Icon = tab.icon;
      let badge = null;
      if (tab.countKey === 'signups') {
        badge = <span className="tab-count">{signupsCount}</span>;
      } else if (tab.countKey === 'unread' && unreadCount > 0) {
        badge = <span className="tab-count unread">{unreadCount}</span>;
      }

      return (
        <button
          key={tab.id}
          className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
          data-testid={tab.testId}
        >
          <Icon size={18} />
          {tab.label}
          {badge}
        </button>
      );
    })}
  </div>
);

export default AdminTabs;
